/*
import {
  ht,
  cr,
  a,
  BoxC,
  BtnC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'stgAreaz',
      boxStlz:
        cr.chkDvc() == 'p' ? 
          a('mt/20 fd/ras')
        : a('f/1 fd/cas'),
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          boxStlz: a(`dw/36 fd/csc mb/2`),
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              abtType: 'stgz',
              boxStlz: a(`mb/2`),
              lblCz: {
                textz: {
          //              pfx: 'メールアドレス変更',
                  pfx: '登録メールアドレス追加・変更',
                }
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [1,0],
                  })
                }
              },
            }),
            cr.c(TextC.N, {
              key: -20,
              boxStlz: a(`mb/2 mh/1`),
              textz: {
                pfx: '登録されたアドレスには、エントリーの当落や施設からのお知らせ等のメールが送られます。'
              }
            }),
            cr.c(TextC.N, {
              key: -30,
              boxStlz: a(`mb/2 mh/1`),
              textz: {
                pfx: 'アドレスは最大３つまで登録が可能で、全てに同じ内容のメールが届きます。'
              }
            })
          ]
        }),

        cr.c(BoxC.N, {
          key: -20,
          boxStlz: a(`dw/36 fd/csc mb/2`),
          oClds: [
            cr.c(BtnC.N, {
              key: -20,
              abtType: 'stgz',
              lblCz: {
                textz: {
    //              pfx: 'パスワード変更',
                  pfx: 'ログインID・パスワード変更',
                }
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [2,0],
                  })
                }
              },
            })
          ]
        }),

      ]
    })

  );
};
